var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportingSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8981 12.7504H15.5781C13.0881 12.7504 11.8281 11.3404 11.8281 8.55045V5.68045C11.8281 4.66045 11.9481 3.20045 13.0081 2.40045C13.8981 1.74045 15.1781 1.69045 17.0681 2.24045C19.5481 2.96045 21.6181 5.03045 22.3381 7.51045C22.8881 9.39045 22.8381 10.6804 22.1781 11.5604C21.3781 12.6304 19.9181 12.7504 18.8981 12.7504ZM14.8581 3.36045C14.4481 3.36045 14.1281 3.44045 13.9181 3.60045C13.5281 3.89045 13.3381 4.57045 13.3381 5.68045V8.56045C13.3381 10.8004 14.1981 11.2604 15.5881 11.2604H18.9081C20.0081 11.2604 20.6881 11.0704 20.9881 10.6804C21.3381 10.2204 21.3081 9.30045 20.9181 7.95045C20.3381 5.98045 18.6381 4.27045 16.6681 3.70045C15.9281 3.47045 15.3281 3.36045 14.8581 3.36045Z",
    fill: "#2F405A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6485 22.7503C11.1185 22.7503 10.5785 22.7103 10.0385 22.6203C5.9485 21.9603 2.6185 18.6403 1.9585 14.5503C1.1085 9.29032 4.4985 4.33032 9.6885 3.27032C10.0985 3.19032 10.4885 3.45032 10.5785 3.85032C10.6585 4.26032 10.3985 4.65032 9.9985 4.74032C5.6085 5.64032 2.7285 9.84032 3.4585 14.3103C4.0185 17.7703 6.8285 20.5803 10.2885 21.1403C14.7785 21.8603 18.9685 18.9703 19.8585 14.5603C19.9385 14.1503 20.3385 13.8903 20.7385 13.9703C21.1485 14.0503 21.4085 14.4503 21.3285 14.8503C20.3785 19.5203 16.2985 22.7503 11.6485 22.7503Z",
    fill: "#2F405A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportingSvg);
export default __webpack_public_path__ + "static/media/reporting_svg.aedc4e64c8c6b9d831317af345fcc35a.svg";
export { ForwardRef as ReactComponent };